import PlayersProxy from '@/proxies/Players';
import PlayersTransform from '@/transforms/Players';
import * as types from './mutation-types';

export default {
  async create({ commit, dispatch }, payload) {
    commit(types.LOADING, true);
    const { afterAction, refreshForTeam, ...options } = payload;
    const proxy = new PlayersProxy();
    try {
      await proxy.create(options);
      const params = refreshForTeam ? { team_id: payload.team_id } : null;
      await dispatch('getItems', params);
      afterAction();
      dispatch('notification/success', 'confirmationmessage.player_created', { root: true });
    } catch (e) {
      dispatch('notification/error', 'errormessage.failed_to_add_player', { root: true });
    } finally {
      commit(types.LOADING, false);
    }
  },
  async getItems({ commit, dispatch, getters }, payload = null) {
    commit(types.LOADING, true);
    const proxy = new PlayersProxy();
    let options = getters.sort;
    if (!!payload) {
      options = Object.assign({}, options, payload);
    }
    try {
      const response = await proxy.getPlayers(options);
      const isMore = payload?.team_id ? true : response.total > getters.items.length;
      commit(types.PLAYERS, PlayersTransform.fetchCollection(response.players));
      commit(types.MORE, isMore);
      commit(types.TOTAL, response.total);
    } catch (e) {
      dispatch('notification/error', 'errormessage.failed_to_get_players', { root: true });
    } finally {
      commit(types.LOADING, false);
    }
  },
  async getItem({ commit, dispatch }, payload) {
    const proxy = new PlayersProxy();
    try {
      const response = await proxy.find(payload);
      commit(types.PLAYER, PlayersTransform.fetch(response));
    } catch (e) {
      dispatch('notification/error', ['errormessage.failed_to_get_player', {player_id: payload}], { root: true });
    }
  },
  addPlayer({ commit }, payload) {
    commit(types.PLAYERS, [payload]);
  },
  async deleteItem({ commit, dispatch, state }, payload) {
    const proxy = new PlayersProxy();
    try {
      await proxy.delete(payload);
      commit(types.DELETE, payload);
      const deletionCount = Array.isArray(payload) ? payload.length : 1;
      commit(types.TOTAL, state.total - deletionCount);
      dispatch('notification/success', 'confirmationmessage.player_deleted', { root: true });
    } catch (e) {
      dispatch('notification/error', 'errormessage.failed_to_delete_player', { root: true });
    }
  },
  sortItems({ commit, dispatch }, payload) {
    commit(types.SORT, payload);
    dispatch('getItems');
  },
  clearItems({ commit }) {
    commit(types.CLEAR_ITEMS);
  },
  resetFilter({ commit, getters }) {
    commit(types.RESET_FILTER);
    commit(types.SORT, getters.defaultSort);
  },
  async refresh({ commit, getters }) {
    commit(types.LOADING, true);
    const proxy = new PlayersProxy();
    try {
      const response = await proxy.getPlayers({ ...getters.sort, ...{ page: 1, limit: getters.items.length } });
      commit(types.PLAYERS, PlayersTransform.fetchCollection(response.players));
    } catch (e) {
      dispatch('notification/error', 'errormessage.failed_to_get_players', { root: true });
    } finally {
      commit(types.LOADING, false);
    }
  },
  refreshLocally({ commit, dispatch, getters }, payload) {
    try {
      const players = getters.items.map(el => {
        if (el.id === payload._id) {
          return PlayersTransform.updateItem(el, payload);
        }
        return el;
      });
      commit(types.PLAYERS, players);
    } catch {
      dispatch('refresh');
    }
  },
  async update({ commit, dispatch }, payload) {
    commit(types.LOADING, true);
    const proxy = new PlayersProxy();
    const { id, ...options } = payload;
    try {
      const response = await proxy.update(id, options);
      dispatch('refreshLocally', response);
      dispatch('notification/success', 'confirmationmessage.player_changed', { root: true });
    } catch (e) {
      dispatch('notification/error', 'errormessage.failed_to_update_player', { root: true });
    } finally {
      commit(types.LOADING, false);
    }
  },
};
